export const jobPhoneNumber = (job: Job) => job.fromPhoneNumber || job.org.jobPhoneNumber;
export const jobForwardingPhoneNumber = (job: Job) =>
  job.forwardingPhoneNumberForCalls || job.org.jobForwardingPhoneNumber;
